module.exports = __webpack_public_path__ + "img/home_bg_zh.c960fece.png";